import React from 'react'

import * as S from './Twitter.styled'
import type { Props } from './Twitter.types'

export const Twitter = ({ avatar, name, nick, url, children }: Props) => (
  <S.Container href={url} target="_blank" rel="noopener noreferrer">
    <S.Header>
      <S.Figure>
        <S.Avatar>{avatar}</S.Avatar>

        <S.Figcaption>
          <S.Name>{name}</S.Name>

          <S.Nick>{nick}</S.Nick>
        </S.Figcaption>
      </S.Figure>

      <S.Logo>
        <S.TwitterIcon width="100%" />
      </S.Logo>
    </S.Header>

    <S.Content>{children}</S.Content>
  </S.Container>
)
